export enum BusinessCategory {
    LOCAL_BUSINESS = 'local_business',
    BRAND = 'brand',
}
